var InfiniteProductScroll = function ajaxConstructor(settings) {
  var default_Data = {
    container: "#infiniteLoop",
    method: "scroll",
    callback: null,
    loadingText: "Loading Now....",
    pagination: "#infinitePagination",
    offset: 0,
    loadingDelay: 2000,
  };

  var data = settings || {};
  this.data = Object.assign(default_Data, data);

  this.infiprodProductClick = this.infiprodProductClick.bind(this);
  this.infiprodProductScroll = this.infiprodProductScroll.bind(this);
  this.infiprodProductDestroy = this.infiprodProductDestroy.bind(this);
  this.infiprodStopProductMultipleClicks = this.infiprodStopProductMultipleClicks.bind(this);
  this.infiprodProductPaginationlnView = this.infiprodProductPaginationlnView.bind(this);

  this.infiprodProductpagination = document.querySelector(this.data.pagination);
  this.infiprodProductcontainer = document.querySelector(this.data.container);

  this.infiprodProductInitialize();
};

InfiniteProductScroll.prototype.infiprodProductInitialize = function basedProductsInitializeTheCorrectFunctionsMethod() {
  if (this.infiprodProductcontainer) {
    var initialidata = {
      click: this.infiprodProductClick,
      scroll: this.infiprodProductScroll,
    };
    if (initialidata[this.data.method]) {
      initialidata[this.data.method]();
    }
  }
};

InfiniteProductScroll.prototype.infiprodProductScroll = function productsPageScrolling() {
  if (this.infiprodProductpagination) {
    document.addEventListener("scroll", this.infiprodProductPaginationlnView);
    window.addEventListener("resize", this.infiprodProductPaginationlnView);
    window.addEventListener("orientationchange", this.infiprodProductPaginationlnView);
  }
};

InfiniteProductScroll.prototype.infiprodProductClick = function productsPageClicking() {
  if (this.infiprodProductpagination) {
    this.nextPageLinkElement = this.infiprodProductpagination.querySelector("a");
    this.clickActive = true;
    if (this.nextPageLinkElement) {
      this.nextPageLinkElement.addEventListener("click", this.infiprodStopProductMultipleClicks);
    }
  }
};

InfiniteProductScroll.prototype.infiprodStopProductMultipleClicks = function prouctPageHandleClickEvent(event) {
  event.preventDefault();
  if (this.clickActive) {
    this.nextPageLinkElement.innerHTML = this.data.loadingText;
    this.nextPageUrl = this.nextPageLinkElement.href;
    this.clickActive = false;
    this.loadMore();
  }
};

InfiniteProductScroll.prototype.infiprodProductPaginationlnView = function prouctPageHandleScrollEvent() {
  var top = this.infiprodProductpagination.getBoundingClientRect().top - this.data.offset;
  var bottom = this.infiprodProductpagination.getBoundingClientRect().bottom + this.data.offset;

  if (top <= window.innerHeight && bottom >= 0) {
    this.nextPageLinkElement = this.infiprodProductpagination.querySelector("a");
    this.removeScrollListener();

    if (this.nextPageLinkElement) {
      this.nextPageLinkElement.innerHTML = this.data.loadingText;
      this.nextPageUrl = this.nextPageLinkElement.href;
      this.loadMore();
    }
  }
};

InfiniteProductScroll.prototype.loadMore = function nextPageRequest() {
  var loaderElement = document.getElementById("loader");
  if (loaderElement) loaderElement.style.display = "block";

  setTimeout(() => {
    this.request = new XMLHttpRequest();
    this.request.onreadystatechange = function success() {
      if (this.request.readyState === 4 && this.request.status === 200) {
        var createdPagination = this.request.responseXML.querySelector(this.data.pagination);
        var createdContainer = this.request.responseXML.querySelector(this.data.container);

        if (createdPagination) {
          this.infiprodProductpagination.innerHTML = createdPagination.innerHTML;
        } else {
          this.infiprodProductpagination.innerHTML = ""; // Remove pagination if none left
        }

        if (createdContainer) {
          this.infiprodProductcontainer.insertAdjacentHTML("beforeend", createdContainer.innerHTML);
        }

        if (this.data.callback && typeof this.data.callback === "function") {
          this.data.callback(this.request.responseXML);
        }

        if (!this.request.responseXML.querySelector(`${this.data.pagination} a`)) {
          console.log("No more products to load.");
          this.removeScrollListener();
          if (loaderElement) loaderElement.style.display = "none";
        } else {
          this.infiprodProductInitialize();
        }
      }
    }.bind(this);

    this.request.open("GET", this.nextPageUrl);
    this.request.responseType = "document";
    this.request.send();
  }, this.loadingDelay);
};

InfiniteProductScroll.prototype.removeScrollListener = function removeProductScroll() {
  document.removeEventListener("scroll", this.infiprodProductPaginationlnView);
  window.removeEventListener("resize", this.infiprodProductPaginationlnView);
  window.removeEventListener("orientationchange", this.infiprodProductPaginationlnView);
};

InfiniteProductScroll.prototype.infiprodProductDestroy = function removeProductReturnData() {
  var yereData = {
    click: this.removeClickListener,
    scroll: this.removeScrollListener,
  };
  if (yereData[this.data.method]) {
    yereData[this.data.method]();
  }
  return this;
};

InfiniteProductScroll.prototype.removeClickListener = function removeProductClick() {
  if (this.nextPageLinkElement) {
    this.nextPageLinkElement.removeEventListener("click", this.infiprodStopProductMultipleClicks);
  }
};
